// Compact leaderboard panel — each player's running total, sorted desc.
// Anar (spectator) intentionally never appears here per spec §7.13.

const TIER_COLOURS = ['text-copper', 'text-fg-secondary', 'text-iceberg-dark'];

export default function Leaderboard({ leaderboard, players, activePlayerId }) {
  if (!leaderboard) return null;
  const rows = (players || [])
    .map((p) => {
      const stats = leaderboard.players?.[p.id] || { points: 0, submissions: 0 };
      return { ...p, ...stats };
    })
    .sort((a, b) => b.points - a.points);

  return (
    <section className="card overflow-hidden">
      <header className="flex items-center justify-between border-b border-border-tertiary bg-bg-secondary px-4 py-2 font-mono text-[10px] uppercase tracking-wider text-fg-tertiary">
        <span>standings</span>
        {leaderboard.updated_at && <span>updated {timeAgo(leaderboard.updated_at)}</span>}
      </header>
      <ul className="divide-y divide-border-tertiary">
        {rows.map((row, i) => (
          <li
            key={row.id}
            className={[
              'flex items-center justify-between px-4 py-3',
              row.id === activePlayerId ? 'bg-bg-tertiary' : '',
            ].join(' ')}
          >
            <div className="flex items-center gap-3">
              <span className={`tabular-nums font-mono text-sm ${TIER_COLOURS[i] || 'text-fg-tertiary'}`}>
                {String(i + 1).padStart(2, '0')}
              </span>
              <div>
                <p className="font-medium">{row.display_name || row.name}</p>
                <p className="font-mono text-[10px] uppercase tracking-wider text-fg-tertiary">
                  {row.submissions} submission{row.submissions === 1 ? '' : 's'}
                </p>
              </div>
            </div>
            <span className="tabular-nums font-mono text-lg text-fg-primary">{row.points}</span>
          </li>
        ))}
        {rows.length === 0 && (
          <li className="px-4 py-6 text-center font-mono text-[11px] uppercase tracking-wider text-fg-tertiary">
            no submissions yet
          </li>
        )}
      </ul>
    </section>
  );
}

function timeAgo(iso) {
  const ms = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(ms)) return '';
  if (ms < 60_000) return 'now';
  const min = Math.floor(ms / 60_000);
  if (min < 60) return `${min}m`;
  return `${Math.floor(min / 60)}h`;
}
